var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !!_vm.row.childList
    ? _c(
        "div",
        _vm._l(_vm.row.childList, function (rowItem) {
          return _c(
            "Row",
            { key: rowItem.optionId, staticClass: "expand-row" },
            [
              _c("Col", { attrs: { span: "5" } }, [
                _c("span", { staticClass: "expand-value" }, [
                  _vm._v(_vm._s(rowItem.name)),
                ]),
              ]),
              _c("Col", { attrs: { span: "3" } }, [
                _c("span", { staticClass: "expand-value" }, [
                  _vm._v(_vm._s(rowItem.code)),
                ]),
              ]),
              _c("Col", { attrs: { span: "3" } }, [
                _c("span", { staticClass: "expand-value" }, [_vm._v("单项")]),
              ]),
              _c("Col", { attrs: { span: "3" } }, [
                _c("span", { staticClass: "expand-value" }, [
                  _vm._v(_vm._s(_vm.row.bloodTubeName)),
                ]),
              ]),
              _c("Col", { attrs: { span: "3" } }, [
                _c("span", { staticClass: "expand-value" }, [
                  _vm._v(_vm._s(_vm.row.inspectOrganizeName)),
                ]),
              ]),
            ],
            1
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }